module.exports = __webpack_public_path__ + "static/media/c7bannerModulE_small.f779d49b.jpg";